<template>
  <div class="section-content">

    <ServeCenter
      :request="request"
      :serveUrl="serveUrl"
      v-if="token"
      :loginUrl='loginUrl'
      :showPublic="showPublic"
      :schoolCode="schoolCode"
      :imgBaseUrl = "configR.IMG_BASE_URL"
    ></ServeCenter>
    <ServeCenter
      :request="request"
      :serveUrl="serveUrl"
      :loginUrl="loginUrl"
      :showPublic="showPublic"
      :schoolCode = "configR.SCHOOL_CODE"
      :imgBaseUrl = "configR.IMG_BASE_URL"
      openApi
      v-else
    ></ServeCenter>

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import configR from '@/configs.js';
export default {
  name: "Service",
  props: {},
  data() {
    return {
      configR: configR.envConfigs,
      loginUrl: `${configR.envConfigs.VUE_APP_CAS_URL}login?service=${encodeURIComponent(
        configR.envConfigs.VUE_APP_URL
      )}`,
      showPublic: configR.envConfigs.SHOW_PUBLIC_SERVE,
      //学校名称
      schoolCode: configR.envConfigs.SCHOOL_CODE,
    };
  },
  computed: {
    ...mapGetters(["token", "serveUrl", "request", ]),
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";
.section-content {
  max-width: 1920px;
  margin: 0 auto;
  .service {
    width: 100%;
    flex: 1;
  }
  .xuegong-sc {
    min-height: calc(100vh - 60px);
  }
}

.section-wrapper {
  .service {
    &-recommendation {
      width: 220px;
    }

    &-container {
      width: calc(100% - 220px);

      .ServeList-filter .z-search {
        border: none;
        color: #fff;

        input {
          outline: none;
        }
      }
    }
  }
}
</style>
